import axios from "axios";

export const fetchData = async () => {
  const baseUrl = "https://htprdapi.hightable.ai";

  const accessToken = localStorage.getItem("@user");

  try {
    const response = await axios.get(`${baseUrl}/users/questions`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    // const response = await axios.get(url);
    return response.data; // Return the data from the API response
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error; // Throw the error so it can be handled by the caller
  }
};
